import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhotocrowdComponent } from './simple-icons-photocrowd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhotocrowdComponent ],
    exports:      [ SimpleIconsPhotocrowdComponent ],
    bootstrap:    []
})
export class SimpleIconsPhotocrowdModule {}
